import React, { useEffect, useState } from 'react';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, CircularProgress, Box, Button } from '@mui/material';
import axios from 'axios';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';
import BankVerificationForm from './BankVerificationForm';
import UserRefunds from './UserRefunds';
import { useNavigate } from 'react-router-dom';


const API_URL = process.env.REACT_APP_API_URL;

const TeacherSessions = ({ userId, onLogout }) => {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        const response = await axios.post(`${API_URL}/get_teacher_sessions/`, {
          user_id: userId
        });
        setSessions(response.data.sessions);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching sessions:', error);
        setLoading(false);
      }
    };

    fetchSessions();
  }, [userId]);

  const handleRedirect = () => {
    navigate('/bank-details');  // Redirect to meeting guidelines page
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress color="primary" />
      </Box>
    );
  }

  return (
    <div>
      <Header1 userId={userId} onLogout={onLogout} />

      <Typography
        variant="h3"
        component="h1"
        align="center"
        fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
        sx={{
          backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
          mt: 2,
          letterSpacing: 10,
          WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
          color: 'transparent',  // Makes the text itself transparent to show the gradient
        }}
        gutterBottom
      >
        Payments
      </Typography>

      <Grid container spacing={3} sx={{ mt: 5, px: 2 }}>



        {sessions && (
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                variant="contained"
                color="info"
                onClick={handleRedirect}
                sx={{
                  letterSpacing: 3,
                  width: { xs: '100%', sm: 'auto' },
                  padding: { xs: '0.75rem 1rem', sm: '0.875rem 1.5rem' },
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  marginTop: { xs: '1rem', sm: '1.5rem' },
                }}
              >
                Bank Details
              </Button>
            </Box>
          </Grid>
        )}


        <Grid item xs={12}>

          <TableContainer
            component={Paper}
            sx={{
              overflowX: 'auto',               // Ensures the table is scrollable on small screens
              maxWidth: '100%',                // Ensure it doesn't exceed container width
              margin: '0 auto',                // Centers the table container
              padding: 2,                      // Adds some padding around the table
              backgroundColor: '#1111',      // Dark background for the table container
              borderRadius: 2,                 // Rounded corners for a modern look
              boxShadow: 3,                    // Adds a subtle shadow around the table container for better focus
            }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="teacher sessions table">
              <TableHead>
                <TableRow sx={{ backgroundColor: '#2222', color: '#fff' }}>
                  <TableCell sx={{ fontWeight: 'bold', color: '#fff', textAlign: 'center', letterSpacing: 3, }}>Session ID</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: '#fff', textAlign: 'center', letterSpacing: 3, }}>Date</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: '#fff', textAlign: 'center', letterSpacing: 3, }}>Time</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: '#fff', textAlign: 'center', letterSpacing: 3, }}>Topic Name</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: '#fff', textAlign: 'center', letterSpacing: 3, }}>Attendees</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: '#fff', textAlign: 'center', letterSpacing: 3, }}>Price</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: '#fff', textAlign: 'center', letterSpacing: 3, }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sessions.map((session) => (
                  <TableRow
                    key={session.session_id}
                    sx={{
                      backgroundColor: '#3333',   // Dark row background for a consistent dark theme
                      color: '#e0e0e0',              // Light text color for better contrast
                      '&:nth-of-type(odd)': {
                        backgroundColor: '#3333',  // Slightly lighter color for odd rows
                      },
                      '&:hover': {
                        backgroundColor: '#444',     // Subtle hover effect for better interaction
                      },
                    }}
                  >
                    <TableCell sx={{ textAlign: 'center', letterSpacing: 2, }}>{session.session_id}</TableCell>
                    <TableCell sx={{ textAlign: 'center', letterSpacing: 2, }}>{session.date}</TableCell>
                    <TableCell sx={{ textAlign: 'center', letterSpacing: 2, }}>{session.time}</TableCell>
                    <TableCell sx={{ textAlign: 'center', letterSpacing: 2 }}>
                      {session.topic_name.length > 50
                        ? `${session.topic_name.slice(0, 50)}...`
                        : session.topic_name}
                    </TableCell>
                    <TableCell sx={{ textAlign: 'center', letterSpacing: 2, }}>{session.attendees}</TableCell>
                    <TableCell sx={{ textAlign: 'center', letterSpacing: 2, }}>{session.price}</TableCell>
                    <TableCell sx={{ textAlign: 'center', letterSpacing: 2, }}>{session.status}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>





      </Grid>

      <Footer2 />
    </div>
  );
};

export default TeacherSessions;
